import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const HistoryContext = createContext();

export const HistoryProvider = ({ children }) => {
  const location = useLocation();
  const [historyStack, setHistoryStack] = useState([]);

  useEffect(() => {
    setHistoryStack(prevStack => {
      const updatedStack = [...prevStack, location.pathname];
      return updatedStack.slice(-10);
    });
  }, [location]);

  return <HistoryContext.Provider value={historyStack}>{children}</HistoryContext.Provider>;
};

export const useHistoryStack = () => useContext(HistoryContext);
